<template>
  <div class="flex justify-center h-full">
    <button @click="toggle" class="cursor-pointer secondary button py-1 px-2 hover:bg-gray-100 w-9">
      {{ dayNumber }}
    </button>

    <Popover ref="op" class="w-80 bg-white shadow rounded-md">
      <div class="popup-content p-4">
        <header class="mb-4">
          <h1 class="mb-0 text-md text-base text-slate-950 font-bold">
            {{ formattedDate }}
          </h1>
        </header>
        
        <div class="flex flex-col space-y-3">
          <!-- Appointments Section -->
          <div v-if="props.dayAppointments.length > 0" class="space-y-2">
            <div v-for="appointment in props.dayAppointments" :key="appointment.id">
              <div :id="`meeting-${appointment.id}`" class="flex space-y-2 space-x-3 items-baseline">
                <div class="status label h-fit" :class="appointment.status_class">{{ appointment.status_text }}</div>

                <div class="flex flex-col">
                  <div>
                    <a open_in="modal-box" class="!font-normal" data-action="click->modal#open" aria-controls="modal-box" aria-haspopup="true" :aria-label="appointment.name" :href="appointment.url">{{ appointment.title }}</a>
                  </div>

                  <div class="times flex flex-col">
                    <div class="text-sm text-gray-600 space-y-1">
                      <div v-for="time in appointment.times" :key="time.id">
                        {{ time.time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Events Section -->
          <div v-if="props.dayEvents.length > 0" class="space-y-2">
            <div class="flex flex-wrap gap-2">
              <div v-for="event in props.dayEvents" :key="event.id">
                <div :id="`event-${event.id}`" class="flex space-y-2 space-x-3 items-baseline">
                  <div class="status label h-fit" :class="event.status_class">{{ event.status_text }}</div>

                  <div class="flex flex-col">
                    <div>
                      <a open_in="modal-box" class="!font-normal" data-action="click->modal#open" aria-controls="modal-box" aria-haspopup="true" :aria-label="event.title" :href="event.url">{{ event.title }}</a>
                    </div>

                    <div class="times flex flex-col">
                      <div class="text-sm text-gray-600 space-y-1">
                          {{ event.time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Orientations Section -->
          <div v-if="props.dayOrientations.length > 0" class="space-y-2">
            <div class="flex flex-wrap gap-2">
              <div v-for="orientation in props.dayOrientations" :key="orientation.id">
                <div :id="`orientation-${orientation.id}`" class="flex space-y-2 space-x-3 items-baseline">
                  <div class="status label h-fit" :class="orientation.status_class">{{ orientation.status_text }}</div>

                  <div class="flex flex-col">
                    <div>
                      <a open_in="modal-box" class="!font-normal" data-action="click->modal#open" aria-controls="modal-box" aria-haspopup="true" :aria-label="orientation.title" :href="orientation.url">{{ orientation.title }}</a>
                    </div>

                    <div class="times flex flex-col">
                      <div class="text-sm text-gray-600 space-y-1">
                          {{ orientation.time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div v-if="hasNoItems" class="text-gray-500 text-sm">
            No events scheduled for this day
          </div>
        </div>
      </div>
    </Popover>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import Popover from 'primevue/popover';

const op = ref();

const props = defineProps({
  date:             { type: String, required: true },
  dayNumber:        { type: [String, Number], required: true },
  dayAppointments:  { type: Array, default: () => [] },
  dayEvents:        { type: Array, default: () => {} },
  dayOrientations:  { type: Array, default: () => {} },
  formattedDate:    { type: String, required: true }
});

// Show empty state if nothing
const hasNoItems = computed(() => 
  props.dayAppointments.length === 0 &&
  props.dayEvents.length === 0 &&
  props.dayOrientations.length === 0
);

const toggle = (event) => {
  op.value.toggle(event);
};
</script>
